import React from 'react'
import { Col, Row } from 'react-bootstrap'
import _ from 'underscore'
import { validateField } from './FieldValidations'

/**
 * To set focus in the field.
 * @params input
 * @params rowId
 */
export const handleSetFocus = (input, rowId, inputRefs) => {
	const nextRef = inputRefs[input] ? inputRefs[input][rowId] : null
	// console.log(nextRef, rowId, '::::focus<>input::', input)
	if (nextRef) {
		if (input === 'fec_entrega' && nextRef.current) {
			nextRef.current.setFocus()
		} else if (input === 'addToCart') {
			nextRef.current.focus()
		} else if (nextRef.current && nextRef.current.element) {
			nextRef.current.element.focus()
		} else {
			nextRef.current.focus()
		}
	}
}

/**
 * callback used when table is render to set
 * focus in the first editable field
 * @params firstRefs
 */

export const handleIsRendeTableFinish = (firstRefs) => {
	if (firstRefs && firstRefs.current) {
		if (firstRefs.current.element) {
			firstRefs.current.element.focus()
		} else {
			firstRefs.current.focus()
		}
	}
}

export const isInputEnabled = (input, rowId, inputRefs) => {
	const nextRef = inputRefs[input] ? inputRefs[input][rowId] : null
	if (nextRef) {
		return nextRef.current.props ? !nextRef.current.props.disabled : null
	}
	return null
}

/**
 * To validate if the field values changed
 * @params id row
 * @params fieldId
 * @params value
 * @params idSearch
 * @params rows
 */
export const isValueChange = (
	rowId,
	fieldId,
	value,
	idSearch = 'niprod',
	rows
) => {
	if (value) {
		const searchParams = {}
		searchParams[idSearch] = rowId
		const updateIndex = _.findIndex(rows, searchParams)
		if (updateIndex < 0) {
			return false
		}

		const updateValue =
			!_.isNull(rows[updateIndex][fieldId]) ||
			!_.isUndefined(rows[updateIndex][fieldId])
				? rows[updateIndex][fieldId]
				: null

		if (updateValue === null) {
			return true
		} else if (String(updateValue) === String(value)) {
			return false
		} else {
			return true
		}
	}

	return false
}

/**
 * to get props options
 * @param {*} props
 * @returns {Object} props options
 */
export const getInputOptions = (props) => {
	const {
		row,
		field,
		value,
		inputRefs,
		primaryKey,
		onChangeInput,
		onEnterKeyPress
	} = props
	const fieldId = field.idCampo.trim()
	const rightFields = ['cantidad', 'pcio_unit', 'neto', 'cant_afec']
	const inputStyle = rightFields.includes(fieldId) ? { textAlign: 'right' } : {}

	return {
		fwRef: field.editable ? inputRefs[fieldId][row[primaryKey]] : null,
		inputFormCol: { sm: 12 },
		fields: [{ ...field, label: false }],
		label: false,
		inputId: `${fieldId}`,
		id: `${fieldId}-${row[primaryKey]}`,
		name: `${fieldId}-${row[primaryKey]}`,
		colLabel: 'col-sm-4',
		colInput: 'col-sm-8',
		divStyle: { paddingLeft: '10px', paddingRight: '10px' },
		disable: false,
		value,
		styles: inputStyle,
		rowStyle: { marginBottom: '5px' },
		onBlur: () => {},
		popperPlacement: 'bottom-end',
		autoComplete: 'Off',
		handleEnterKey: (event, value) =>
			onEnterKeyPress({ event, value, fieldId, row }),
		onChange: (value, event) => onChangeInput({ event, value, fieldId, row })
	}
}

/**
 * to creates a reference array of all table inputs
 * @param field IFieldStructure
 * @param rowId string
 */
export const getInputRefs = (field, rowId, first, inputRefs) => {
	let firstInputRef = null
	const fieldId = field.idCampo.trim()

	if (field.editable && !inputRefs[fieldId]) {
		inputRefs[fieldId] = {}
	}

	if (field.editable && !inputRefs[fieldId][rowId]) {
		const customRef = React.createRef()
		inputRefs[fieldId][rowId] = customRef
		if (first === null) {
			firstInputRef = customRef
		}
	}

	return { inputRefs, firstInputRef }
}

export const prevAddToCart = (props) => {
	const { fieldsTable, excludeFields, setTableDataProducts, row, t } = props
	const message = []
	let flag = true

	fieldsTable.forEach((field) => {
		const fieldId = field.idCampo.trim()
		if (parseInt(field.requerido) && !excludeFields.includes(fieldId)) {
			if (!validateField(row[fieldId], field.valid)) {
				const params = { niprod: row.niprod }
				params[fieldId] = 'error_input'
				setTableDataProducts(params)
				message.push(
					'El campo ' + t('validation-required', { field: field.label })
				)
				flag = false
			}
		}
	})

	return flag
}

export const renderReadOnlyAttributes = (row) => {
	if (row && !_.isEmpty(row?.atributos)) {
		const cols = row.atributos.map((atrb) => {
			return (
				<Col key={atrb.cod_atrib} className={'col-6 p-2'}>
					<b>{`${atrb.desc_atrib}:`}</b> {atrb.desc_dato}
				</Col>
			)
		})
		return <Row className={'container mt-2 mb-3'}>{cols}</Row>
	}

	return <div />
}
